import { z } from "zod";

export const transferSchema = z.object({
  id: z.string(),
  status: z.string(),
  // Backend serializes `amount` as a string; coerce so consumers keep a
  // `number` and real transfers aren't dropped by `looseArray(transferSchema)`.
  amount: z.coerce.number(),
  created_at: z.string(),
  direction: z.string(),
  type: z.string(),
});

export const rapydTransferSchema = transferSchema.extend({
  transfer_status: z.string(),
});

export const achRelationshipStatusSchema = z.enum([
  "QUEUED",
  "CANCEL_REQUESTED",
  "CANCEL_SENT",
  "CANCEL_FAILED",
  "PENDING",
  "SENT_TO_CLEARING",
  "APPROVED",
  "CANCELED",
  "REJECTED",
]);

export const achRelationshipSchema = z.object({
  id: z.string(),
  account_id: z.string(),
  status: achRelationshipStatusSchema,
  approval_method: z.string(),
  // Gobroker's `RelationshipResponse` uses pointers without `omitempty`, so nil
  // values serialize as an explicit `null`. `nullish` keeps a relationship with
  // null Plaid metadata (e.g. a manually linked bank) instead of `looseArray`
  // dropping the whole valid record and hiding the user's linked bank account.
  account_name: z.string().nullish(),
  plaid_institution: z.string().nullish(),
  plaid_verification_status: z.string().nullish(),
});

export const bankInstitutionSchema = z.object({
  logo: z
    .string()
    .nullish()
    .transform((v) => v ?? ""),
  brand_name: z
    .string()
    .nullish()
    .transform((v) => v ?? ""),
});

export const bankInstitutionResponseSchema = z.object({
  institution: bankInstitutionSchema,
});

export const instantAchTierSchema = z.object({
  transfer_limit: z.string(),
});

export const instantAchEligibilitySchema = z.discriminatedUnion("eligible", [
  z.object({
    eligible: z.literal(true),
    current_tier: instantAchTierSchema,
  }),
  z.object({
    eligible: z.literal(false),
    ineligibility_reason: z.string(),
  }),
]);
